import { render, staticRenderFns } from "./crossMac.vue?vue&type=template&id=1c25db62&scoped=true&"
import script from "./crossMac.vue?vue&type=script&lang=js&"
export * from "./crossMac.vue?vue&type=script&lang=js&"
import style0 from "./crossMac.vue?vue&type=style&index=0&id=1c25db62&scoped=true&lang=css&"
import style1 from "./crossMac.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c25db62",
  null
  
)

export default component.exports